<template>
  <gg-card>
    <gg-card-header>
      Subaccounts
    </gg-card-header>
    <gg-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Username
            </th>
            <th class="text-left">
              Scheduled For
            </th>
            <th class="text-left">
              Completed At
            </th>
            <th class="text-left">
              Status
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="subMigration in subMigrations" :key="`sm-${subMigration.id}`">
            <td>
              {{ subMigration.resold_username }}
            </td>
            <td>
              {{ subMigration.scheduled_for }}
            </td>
            <td>
              {{ subMigration.completed_at }}
            </td>
            <td>
              <v-icon small class="mb-1" :color="migrationStatusColor(subMigration.status)">
                mdi-circle
              </v-icon>
              {{ subMigration.status }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { migrationStatusColor } from 'Helpers/helpers'

export default {
  name: 'SubMigrationsCard',
  props: {
    subMigrations: {
      required: true,
      type: Array
    }
  },
  methods: {
    migrationStatusColor
  }
}
</script>
